import {
  Badge,
  Button,
  createSortableColumn,
  DataTable,
  type TanstackReactTable,
} from "@devhop/ui";
import type { OutsourceCategoryDTO } from "../../domain/contracts";

const PAYEE_LABELS = {
  individual: "ບຸກຄົນ",
  team: "ທີມ",
} as const;

type OutsourceCategoryTableProps = {
  data: OutsourceCategoryDTO[];
  isLoading?: boolean;
  canUpdate?: boolean;
  onToggleActive: (row: OutsourceCategoryDTO) => void;
  togglingId?: string | null;
};

export function OutsourceCategoryTable({
  data,
  isLoading,
  canUpdate,
  onToggleActive,
  togglingId,
}: OutsourceCategoryTableProps) {
  const columns: TanstackReactTable.ColumnDef<OutsourceCategoryDTO>[] = [
    createSortableColumn("nameLo", "ຊື່ (ລາວ)"),
    createSortableColumn("slug", "Slug"),
    {
      id: "defaultPayeeType",
      header: "Payee default",
      cell: ({ row }) =>
        row.original.defaultPayeeType
          ? PAYEE_LABELS[row.original.defaultPayeeType]
          : "—",
    },
    {
      id: "sortOrder",
      header: "ລຳດັບ",
      cell: ({ row }) => row.original.sortOrder,
    },
    {
      id: "status",
      header: "ສະຖານະ",
      cell: ({ row }) =>
        row.original.isActive ? (
          <Badge variant="outline">ໃຊ້ງານ</Badge>
        ) : (
          <Badge variant="secondary">ປິດໃຊ້</Badge>
        ),
    },
    ...(canUpdate
      ? [
          {
            id: "actions",
            header: "",
            cell: ({ row }: { row: { original: OutsourceCategoryDTO } }) => (
              <Button
                type="button"
                size="sm"
                variant="outline"
                disabled={togglingId === row.original.id}
                onClick={() => onToggleActive(row.original)}
              >
                {row.original.isActive ? "ປິດໃຊ້" : "ເປີດໃຊ້"}
              </Button>
            ),
          } as TanstackReactTable.ColumnDef<OutsourceCategoryDTO>,
        ]
      : []),
  ];

  return (
    <DataTable<OutsourceCategoryDTO, unknown>
      noDataMessage="ບໍ່ພົບຫມວດ"
      data={data}
      columns={columns}
      isLoading={isLoading}
      offset={0}
      limit={data.length || 20}
      totalCount={data.length}
      onPaginationChange={() => {}}
    />
  );
}
